import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class RelatedResourceController extends EzController {
  relatedResourceClick = (event) => {
    const resourceId = event.currentTarget.parentNode.getAttribute('data-item-id');
    this.sendRelatedResourceClickEvent(resourceId);
  }

  sendRelatedResourceClickEvent(resourceId) {
    triggerCustomEvent(events.show_page.related_resource_click, { resourceId });
  }
}
